/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InsurancePayor } from './InsurancePayor';
import {
    InsurancePayorFromJSON,
    InsurancePayorFromJSONTyped,
    InsurancePayorToJSON,
    InsurancePayorToJSONTyped,
} from './InsurancePayor';
import type { PalAuthPlatform } from './PalAuthPlatform';
import {
    PalAuthPlatformFromJSON,
    PalAuthPlatformFromJSONTyped,
    PalAuthPlatformToJSON,
    PalAuthPlatformToJSONTyped,
} from './PalAuthPlatform';

/**
 * 
 * @export
 * @interface PalAuthPlatformPayorForm
 */
export interface PalAuthPlatformPayorForm {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    payor_id?: string;
    /**
     * 
     */
    auth_platform_id?: string;
    /**
     * 
     */
    submission_form?: { [key: string]: any; };
    /**
     * 
     */
    description?: string;
    /**
     * 
     */
    version?: number;
    /**
     * 
     */
    payor?: InsurancePayor;
    /**
     * 
     */
    auth_platform?: PalAuthPlatform;
}

/**
 * Check if a given object implements the PalAuthPlatformPayorForm interface.
 */
export function instanceOfPalAuthPlatformPayorForm(value: object): value is PalAuthPlatformPayorForm {
    return true;
}

export function PalAuthPlatformPayorFormFromJSON(json: any): PalAuthPlatformPayorForm {
    return PalAuthPlatformPayorFormFromJSONTyped(json, false);
}

export function PalAuthPlatformPayorFormFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthPlatformPayorForm {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'payor_id': json['payor_id'] == null ? undefined : json['payor_id'],
        'auth_platform_id': json['auth_platform_id'] == null ? undefined : json['auth_platform_id'],
        'submission_form': json['submission_form'] == null ? undefined : json['submission_form'],
        'description': json['description'] == null ? undefined : json['description'],
        'version': json['version'] == null ? undefined : json['version'],
        'payor': json['payor'] == null ? undefined : InsurancePayorFromJSON(json['payor']),
        'auth_platform': json['auth_platform'] == null ? undefined : PalAuthPlatformFromJSON(json['auth_platform']),
    };
}

export function PalAuthPlatformPayorFormToJSON(json: any): PalAuthPlatformPayorForm {
    return PalAuthPlatformPayorFormToJSONTyped(json, false);
}

export function PalAuthPlatformPayorFormToJSONTyped(value?: PalAuthPlatformPayorForm | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'payor_id': value['payor_id'],
        'auth_platform_id': value['auth_platform_id'],
        'submission_form': value['submission_form'],
        'description': value['description'],
        'version': value['version'],
        'payor': InsurancePayorToJSON(value['payor']),
        'auth_platform': PalAuthPlatformToJSON(value['auth_platform']),
    };
}

